<script lang="ts">
    import { cn } from "@/lib/utils";
    import type { Tag as TagProps } from "./ActivityTag";
    import type { GroupMember } from "./ActivityFunctions";
    import { Tag } from '@/Common';
    import GroupTagPopover from './GroupTagPopover.svelte';

    export let tags: TagProps[]
    // When present alongside a "Group" tag, that tag becomes clickable and opens a popover
    // listing these members instead of rendering as a plain pill.
    export let groupMembers: GroupMember[] = []
    let className: string = undefined
    export {className as class}
</script>

<div class={cn("flex gap-1 flex-wrap", className)} >
    {#each tags as tag}
        {#if tag.label === "Group" && groupMembers.length}
            <GroupTagPopover {tag} members={groupMembers} />
        {:else}
            <Tag {...tag} />
        {/if}
    {/each}
</div>